/**
 * Notes Feature Constants
 */

/** Color swatches available for note color picker */
export const NOTE_COLOR_SWATCHES = [
  '#3b82f6', // Blue (default)
  '#ef4444', // Red
  '#22c55e', // Green
  '#f59e0b', // Amber
  '#8b5cf6', // Purple
  '#ec4899', // Pink
  '#06b6d4', // Cyan
  '#f97316', // Orange
  '#6366f1', // Indigo
  '#84cc16', // Lime
] as const;

/** Maximum note title length */
export const NOTE_TITLE_MAX_LENGTH = 200;

/** Maximum note content size in bytes (500KB) */
export const NOTE_CONTENT_MAX_SIZE = 512_000;

/** Autosave debounce delay in milliseconds */
export const NOTE_AUTOSAVE_DEBOUNCE_MS = 2000;

/** Default note color (blue) */
export const NOTE_DEFAULT_COLOR = '#3b82f6';

/** Default page size for notes list */
export const NOTE_DEFAULT_PAGE_SIZE = 20;

/** Maximum page size for notes list */
export const NOTE_MAX_PAGE_SIZE = 100;

/** Note marker size on map in pixels */
export const NOTE_MAP_MARKER_SIZE = 32;

/** Color swatch size in note filters (pixels) */
export const NOTE_COLOR_SWATCH_SIZE = 24;

/** Sentinel value for the visibility filter Select that disambiguates "no filter" from a real NoteVisibility enum value. */
export const NOTE_VISIBILITY_ALL = 'all';
